<script setup lang="ts">
import {WebForm, WebInput, CustomerSignUp, useWebPopup, ICustomer} from "lct-lib"
import {ref} from "vue";

const {show, hide} = useWebPopup();

const customer = ref<ICustomer>({
    email: "",
    password: "",
});

const form = ref();

const rePassword = ref("");
const imAccept = ref(false);


const submit = async () => {
    try {
        if(rePassword.value !== customer.value.password) {
            show("Passwords don't match");
        }
        show();
        const result = await CustomerSignUp(customer.value);
        show({
            text: "Your account has been successfully created.",
            buttons: [
                {
                    text: "Sign In",
                    handler: () => {
                        location.href = "/sign-in";
                    }
                }
            ]
        });
    } catch (e) {
        show("Have something went wrong");
        console.log(e);
    }
}

</script>

<template>
<div c2c-0 class="cc">
    <div c2c-1 class="w-100%-max:500 p-30-12 >>h1 tc p-b-12">
        <h1>Sign Up</h1>
        <div c2c-2 class="bd sd p-12 m-b-20 br-6 bg-0">
            <web-form ref="form" c2c-3 class="m_end" @submit="submit">

                <web-input type="text" label="First name" v-model="customer.firstname"></web-input>
                <web-input type="text" label="Last name" v-model="customer.lastname"></web-input>
                <web-input type="email" label="Email" v-model="customer.email" required></web-input>
                <web-input type="text" label="Phone" v-model="customer.phone"></web-input>

                <web-input type="password" label="Password" v-model="customer.password" minlength="6" required></web-input>
                <web-input type="password" label="Re-enter Password" v-model="rePassword" required></web-input>
                <label c2c-4 class="block p-t-12">
                    <input type="checkbox" v-model="imAccept" required>
                    By signing up, I accept the <a c2c-5 class="u tb" href="/terms-of-service">Terms & Conditions</a> and <a c2c-6 class="tb u" href="/privacy-policy">Privacy Policy.</a>
                </label>
            </web-form>
            {{imAccept}}
            <button :disabled="!imAccept" c2c-7 class="btl-blue w-100% m-t-30" @click="form.dispatchSubmit">Create Account</button>
        </div>
        <div c2c-8 class="p-12 tc">
            Already have an account? <a c2c-9 class="c-logo tb" href="/sign-in">Log in here.</a>
        </div>
    </div>
</div>
</template>

<style scoped>

</style><style lang="scss" scoped>.cc[c2c-0] {
                        display: flex; flex-direction: column; align-items: center;
                 }.w-100\%-max\:500[c2c-1] {
                        width: 100%;max-width: 500px;
                 }.p-30-12[c2c-1] {
                        padding-top: 30px;padding-right: 12px;padding-bottom: 30px;padding-left: 12px;
                 }.\>\>h1.tc[c2c-1] h1 {
                        text-align: center;
                 }.\>\>h1.p-b-12[c2c-1] h1 {
                        padding-bottom: 12px;
                 }.bd[c2c-2] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.sd[c2c-2] {
                        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2)
                 }.p-12[c2c-2] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.m-b-20[c2c-2] {
                        margin-bottom: 20px;
                 }.br-6[c2c-2] {
                        border-top-left-radius: 6px;border-top-right-radius: 6px;border-bottom-right-radius: 6px;border-bottom-left-radius: 6px;
                 }.bg-0[c2c-2] {
                        background-color: hsl(0, 0%, 100%);
                 }.block[c2c-4] {
                        display: block;
                 }.p-t-12[c2c-4] {
                        padding-top: 12px;
                 }.u[c2c-5] {
                        text-decoration: underline;
                 }.tb[c2c-5] {
                        font-weight: bold;
                 }.tb[c2c-6] {
                        font-weight: bold;
                 }.u[c2c-6] {
                        text-decoration: underline;
                 }.w-100\%[c2c-7] {
                        width: 100%;
                 }.m-t-30[c2c-7] {
                        margin-top: 30px;
                 }.p-12[c2c-8] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.tc[c2c-8] {
                        text-align: center;
                 }.c-logo[c2c-9] {
                        color: hsl(197.39999999999998, 95.9%, 38%);
                 }.tb[c2c-9] {
                        font-weight: bold;
                 }</style>